<header class="view-header">
  <h2 class="view-header__title" [innerHTML]="(pageContent$ | async)?.Heading"></h2>
</header>

<section class="view-body">
  <!-- USER panel -->
  <div class="view-body__panel">
    <header class="panel-header">
      <h3 class="panel-header__title">User{{ isSubmitting ? ' (saving)' : null }}</h3>
    </header>
    <form class="panel-body is-grid--fill is-grid--half" autocomplete="off" [formGroup]="contactForm">
      <!-- FEEDBACK msg list -->
      @if (feedbackMsgs.length > 0) {
      <div class="grid-item full-width">
        <ul class="list naked">
          @for (feedbackMsg of feedbackMsgs; track feedbackMsg) {
          <li [class]="'is-' + feedbackMsg.type">
            {{ feedbackMsg.msg }} @if(feedbackMsg?.type==='error'){ Click <a href="/help">here</a> for support. }
          </li>
          }
        </ul>
      </div>
      }
      <!-- .grid-item (input controls) -->
      <div
        class="grid-item"
        [class]="{ 'is-invalid': (contactForm.get('FirstName')?.touched || contactForm.get('FirstName')?.dirty) && !contactForm.get('FirstName')?.valid }"
      >
        <label for="name-first" class="grid-item__label">First Name</label>
        <input id="name-first" formControlName="FirstName" type="text" class="grid-item__value" />
        @if (contactForm.get('FirstName')?.errors?.required) {
        <span class="error-feedback">Your first name is required.</span>
        }
      </div>
      <div
        class="grid-item"
        [class]="{ 'is-invalid': (contactForm.get('LastName')?.touched || contactForm.get('LastName')?.dirty) && !contactForm.get('LastName')?.valid }"
      >
        <label for="name-last" class="grid-item__label">Last Name</label>
        <input id="name-last" formControlName="LastName" type="text" class="grid-item__value" />
        @if (contactForm.get('LastName')?.errors?.required) {
        <span class="error-feedback">Your last name is required.</span>
        }
      </div>
      @if (!user.IsEmployee && !isCusUser) {
      <div
        class="grid-item"
        [class.is-invalid]='(contactForm.get("Email")?.touched || contactForm.get("Email")?.dirty) && !contactForm.get("Email")?.valid'
      >
        <label for="Email" class="grid-item__label">Email</label>
        <input formControlName="Email" type="email" class="grid-item__value" />
        @if (contactForm.get('Email')?.errors?.required) {
        <span class="error-feedback">A valid email address is required.</span>
        } @if (contactForm.get('Email')?.errors?.email) {
        <span class="error-feedback">This email address is invalid.</span>
        }
      </div>
      } @if (user.IsEmployee || isCusUser) {
      <div class="grid-item">
        <span class="grid-item__label">Email</span>
        <p class="grid-item__value" [title]="user.Email!.toLowerCase()">{{ user.Email!.toLowerCase() }}</p>
      </div>
      }
      <div
        class="grid-item"
        [class.is-invalid]='(contactForm.get("Mobile")?.touched || contactForm.get("Mobile")?.dirty) && !contactForm.get("Mobile")?.valid'
      >
        <label for="Mobile" class="grid-item__label">Mobile Phone</label>
        <input formControlName="Mobile" type="tel" class="grid-item__value" />
        @if (contactForm.get('Mobile')?.errors?.required) {
        <span class="error-feedback">Your mobile phone number is required.</span>
        } @if (contactForm.get('Mobile')?.errors?.pattern) {
        <span class="error-feedback">Please enter a valid number.</span>
        }
      </div>
      <div
        class="grid-item"
        [class.is-invalid]='(contactForm.get("Phone")?.touched || contactForm.get("Phone")?.dirty) && !contactForm.get("Phone")?.valid'
      >
        <label for="Phone" class="grid-item__label">Office Phone</label>
        <input formControlName="Phone" type="tel" class="grid-item__value" />
        @if (contactForm.get('Phone')?.errors?.pattern) {
        <span class="error-feedback">Please enter a valid number.</span>
        }
      </div>
    </form>
    <footer class="panel-footer">
      @if (isContactFormEditable) {
      <button type="button" class="naked secondary" (click)="handleUserPrimaryClick(false)">cancel</button>
      }
      <button
        type="button"
        class="oneok-button oneok-blue oneok-pill"
        [disabled]="isPrimaryButtonDisabled()"
        (click)="handleUserPrimaryClick(isContactFormEditable ? 'save' : true, $event)"
      >
        @if (!isContactFormEditable) {
        <svg-icon src="/assets/svg/user-pen-solid.svg" />
        } @if (isContactFormEditable) {
        <svg-icon src="/assets/svg/thumbs-up.svg" />
        } {{ isContactFormEditable ? 'save ' : 'edit ' }}profile
      </button>
    </footer>
  </div>

  <!-- COMPANY panel -->
  <div class="view-body__panel">
    <ng-container>
      <!-- <form [formGroup]="contactForm" class="panel-body is-grid--fill is-grid--half"> -->
      <header class="panel-header">
        <h3 class="panel-header__title">Company</h3>
      </header>

      <form [formGroup]="accountForm">
        <div class="panel-body is-grid--fit is-grid--half">
          <div class="grid-item">
            <span class="grid-item__label">Company Name</span>
            <p class="grid-item__value">{{ account.AccountName | titlecase }}</p>
          </div>
          <div class="grid-item">
            <span class="grid-item__label">Postal Address</span>
            <p class="grid-item__value">{{ account.Address || '&nbsp;' }}</p>
          </div>
          <div class="grid-item">
            <span class="grid-item__label">Phone Number</span>
            <p class="grid-item__value">{{ account.Phone || '&nbsp;' }}</p>
          </div>
          <div class="grid-item">
            <span class="grid-item__label">Primary ONEOK Contact</span>
            <p class="grid-item__value"><a href="mailto:oneok@service-now.com">Service Desk</a></p>
          </div>
          @if (isAccountAdministratorsVisible()) {
          <div class="grid-item">
            <span class="grid-item__label">Company Administrator(s)</span>
            <ul class="naked grid-item__value">
              @if (isNoAccountAdministrators) {
              <li>Not found!</li>
              } @else { @if (accountAdministrators.length === 0) {
              <li>
                Hang tight… @if (isLoading) {
                <span class="spinner-border spinner-border-sm" id="loading-spinner" role="status"></span>
                }
              </li>
              } @for (admin of accountAdministrators; track admin) {

              <li class="mb-1">
                <a href="mailto:{{ admin.Email }}?subject=ONEOK Customer Portal User Inquiry">{{ admin.FullName }}</a>
              </li>

              } }
            </ul>
          </div>
          }
          <div class="grid-item">
            <span class="grid-item__label">ESAA Signed?</span>

            <div class="form-check form-switch grid-item__label">
              <!-- [disabled]="showEsaaFlagToggle()" -->
              <input
                id="esaa-status"
                class="form-check-input"
                type="checkbox"
                formControlName="esaaStatus"
                (click)="toggleEsaaStatus()"
              />
              <label for="esaa-status" class="form-check-label mt-1 mx-1">{{ acctEsaaStatusText }}</label>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
    @if (isAccoountFormEditable && accountForm.dirty) {
    <footer class="panel-footer">
      <button type="button" class="oneok-button oneok-blue oneok-pill" (click)="updateAccountEsaaStatus($event)">
        @if (isAccoountFormEditable) {
        <svg-icon src="/assets/svg/thumbs-up.svg" />
        } save profile
      </button>
    </footer>
    }
  </div>
</section>
